import React from "react";

import Header from "components/VerticalLayout/Header";
import Sidebar from "components/VerticalLayout/Sidebar";
import Footer from "components/VerticalLayout/Footer";
import { Link } from "react-router-dom";
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Remainders = () => {
  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
  };
  //meta title
  document.title = "Samarth Fruit Company";
  return (
    <div>
      <div id="layout-wrapper">
        <Header></Header>
        <Sidebar></Sidebar>
     
        <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="डॅशबोर्ड" breadcrumbItem="स्मरणपत्रे" />
   

    <div className="row">
            <div className="col">
              <div className="card">
                <div className="card-body">
                  <div className="row" style={{ justifyContent:"space-between" }}>
                    {/* <div className="col-md-2 mb-3" style={{ textAlign: "right" }}>
                      <Link to="/#" type="button" class="btn-add btn-sm  btn btn-primary"></Link>
                    </div> */}
                    <div className="col-md-4" style={{ textAlign: "left" }}><div className="search-box d-inline-block">
                      <div className="position-relative">
                        <label htmlFor="search-bar-0" className="search-label">
                          <span id="search-bar-0-label" className="sr-only">Search this table</span>
                          <input  type="text" className="form-control" placeholder="27 records..." /></label><i className="bx bx-search-alt search-icon"></i></div></div></div>
                    <div className="col-md-2 mb-3" style={{ display:"none" }} ><a className="btn btn-primary" href="/#"><i className="bx bx-plus align-middle"></i> नवीन फॉर्म</a></div>
                  </div>

                  <div className="table-rep-plugin">
                    <div
                      className="table-responsive mb-0"
                      data-pattern="priority-columns"
                    >
                      <table
                        id="tech-companies-2"
                        className="table table-striped table-bordered"
                      >
                        <thead>
                          <tr>
                            <th>अ.क्र.</th>
                            <th>
                              नाव
                            </th>
                            <th>
                              पत्ता
                            </th>

                            <th>फोन नं</th>
                            <th>तारीख</th>
                            
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>रुचिता</td>
                            <td>
                              सावत नगर, नाशिक</td>

                            <td>9156528394</td>
                            <td>23-04-2022</td>

                            <td><Link to="/#" type="button" className="btn-sm btn-view  btn "><div className="tooltip1"><i className="bx bx-file align-middle "><span className="tooltiptext">पहा</span></i></div></Link>
                              <Link to="/#" type="button" className="btn-sm btn-edit btn "><div className="tooltip1"><i className="bx bx-edit align-middle"><span className="tooltiptext">संपादित करा</span></i></div></Link></td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>रुचिता</td>
                            <td>
                              सावत नगर, नाशिक</td>

                            <td>9156528394</td>
                            <td>23-03-2023</td>


                            <td><Link to="/#" type="button" className="btn-sm btn-view  btn "><div className="tooltip1"><i className="bx bx-file align-middle "><span className="tooltiptext">पहा</span></i></div></Link>
                              <Link to="/#" type="button" className="btn-sm btn-edit  btn btn-primary"><div className="tooltip1"><i className="bx bx-edit align-middle"><span className="tooltiptext">संपादित करा</span></i></div></Link></td>
                          </tr>
                        </tbody>
                      </table>
                      
                  </div>
                  <ul className="pagination modal-1" style={{float:"right"}}>
  <li><a href="#" className="prev">«</a></li>
  <li><a href="#" className="active">1</a></li>
  <li> <a href="#">2</a></li>
  <li> <a href="#">3</a></li>
  
  <li><a href="#" className="next">»</a></li>
</ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <Footer></Footer>
    </div>
    </div>
  );
};

export default Remainders;
